import React from 'react';

import { StyledChip, StyledChipList } from './Chip.styles';
import { TChipListProps, TChipProps } from './Chip.types';

const Chip = ({ size = 'md', children, ...props }: TChipProps) => (
  <StyledChip $size={size} {...props}>
    {children}
  </StyledChip>
);

export const ChipList = ({ children, ...props }: TChipListProps) => (
  <StyledChipList {...props}>{children}</StyledChipList>
);

export default Chip;
